// extracted by mini-css-extract-plugin
module.exports = {"Subreddit":"Subreddit_Subreddit__sC_7i","subs":"Subreddit_subs__XAnJO","topic":"Subreddit_topic__3Wjex","subInfo":"Subreddit_subInfo__1rQ6-"};